/* Büromöbel Plus newsletter popup (customer type + one wheel per customer type). No dependencies. */
(function (root, factory) {
  'use strict';
  var script = typeof document !== 'undefined' ? document.currentScript : null;
  var mod = factory(root, script);
  if (typeof module === 'object' && module && module.exports) module.exports = { internals: mod.internals };
  if (typeof window !== 'undefined' && typeof document !== 'undefined') mod.boot();
})(typeof window !== 'undefined' ? window : this, function (root, currentScript) {
  'use strict';

  // ---- Tunables (Briefing: easy to change) ----
  // Wheel per customer type. segments run clockwise from 12 o'clock; odds are weights per amount.
  // Since 25.09. (client) both types spin the same wheel: one 10 € field, two 8 € fields, three 5 € fields,
  // drawn as shown, no 15 € any more. Kept per type so the two can differ again later.
  var WHEEL = {
    odds: [{ amount: 5, weight: 3 }, { amount: 8, weight: 2 }, { amount: 10, weight: 1 }],
    segments: [10, 5, 8, 5, 8, 5]
  };
  var WHEELS = { private: WHEEL, business: WHEEL };
  var WHEEL_ODDS = WHEELS.private.odds;
  var WHEEL_SEGMENTS = WHEELS.private.segments;
  var SPIN_MS = 3600;
  var WIN_PAUSE_MS = 700; // the stopped wheel shows the highlighted win this long before the form appears
  var KLAVIYO_REVISION = '2026-07-15'; // see docs/KLAVIYO.md
  var CUSTOM_SOURCE = 'Popup Kundentyp';
  var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions/';
  var EDGE_MARGIN = 8;
  var VERSION = '1.3.1';
  var NB = '\u00a0';

  var COPY = {
    chooseTitle: 'Willkommen bei Büromöbel Plus',
    chooseText: 'Damit wir Ihnen das Passende zeigen: Für wen richten Sie ein?',
    choosePrivate: 'Für mein Zuhause',
    chooseBusiness: 'Für mein Unternehmen',
    privateTitle: 'Ihr Preisvorteil zum Start: bis zu 10' + NB + '€',
    privateText: 'Einmal drehen und sofort sehen, was Sie erhalten. Jedes Feld gewinnt!',
    claimTitle: 'Ihr Preisvorteil: {betrag}' + NB + '€',
    claimText: 'Für Ihre erste Bestellung ab 100' + NB + '€ Einkaufswert. Tragen Sie Ihre E-Mail-Adresse ein, dann senden wir Ihnen Ihren persönlichen Code.',
    claimSubmit: 'Code anfordern',
    emailLabel: 'E-Mail-Adresse',
    consentPre: 'Ja, ich möchte den Newsletter von Büromöbel Plus mit Angeboten und Tipps rund um moderne Arbeitswelten erhalten. Abmeldung jederzeit möglich. Details in der ',
    consentLink: 'Datenschutzerklärung',
    consentPost: '.',
    spin: 'Jetzt drehen',
    decline: 'Nein danke',
    finePrint: 'Einlösbar ab 100' + NB + '€ Einkaufswert, nicht kombinierbar.',
    privateDoneTitle: 'Sie erhalten {betrag}' + NB + '€ für Ihre erste Bestellung',
    privateDoneText: 'Bitte bestätigen Sie jetzt Ihre E-Mail-Adresse. Danach senden wir Ihnen Ihren persönlichen Code – einlösbar ab 100' + NB + '€ Einkaufswert, 14 Tage gültig. Dazu gilt immer: kostenloser Versand in Deutschland, 60 Tage Rückgaberecht und Tiefpreisgarantie.',
    privateDoneButton: 'Weiter einkaufen',
    businessTitle: 'Ihr Preisvorteil zum Start: bis zu 10' + NB + '€',
    businessText: 'Einmal drehen und sofort sehen, was Sie erhalten. Jedes Feld gewinnt!',
    businessPerksLead: 'Dazu exklusiv für Geschäftskunden:',
    businessPerks: ['Sonderprojektpreise und Mengenrabatte', 'Kauf auf Rechnung', 'Kostenlose Stoff- & Dekormuster',
      'Erste Arbeitsplatzplanung kostenlos', 'Aufbau- & Montageservice', 'Bevorzugte Lieferzeit'],
    businessDoneText: 'Bitte bestätigen Sie jetzt Ihre E-Mail-Adresse. Danach senden wir Ihnen Ihren persönlichen Code, einlösbar ab 100' + NB + '€ Einkaufswert.',
    companyLabel: 'Unternehmen (optional)',
    seatsLabel: 'Anzahl Arbeitsplätze (optional)',
    seatsOptions: [['', 'Bitte wählen'], ['1-4', '1–4'], ['5-19', '5–19'], ['20+', '20+']],
    businessDoneContact: 'Lieber gleich persönlich? Lernen wir uns persönlich kennen, am Telefon: ',
    close: 'Schließen',
    errorSend: 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.',
    errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    errorConsent: 'Bitte bestätigen Sie die Einwilligung.',
    retry: 'Erneut versuchen',
    teaser: 'Bis zu 10' + NB + '€ sichern',
    teaserClose: 'Hinweis schließen',
    wheelLabel: 'Glücksrad mit den Feldern {felder}',
    spinning: 'Das Rad dreht sich.',
    result: 'Ergebnis: {betrag}' + NB + '€',
    fieldsAnd: ' und '
  };

  var DEFAULT_EXCLUDED = ['/cart', '/checkouts/*', '/checkout', '/account/*', '/policies/*', '/pages/contact',
    '/pages/kontakt', '/pages/b2b-kunden', '/pages/b2b-vorteile', '/pages/bueromoebel-auf-rechnung', '/pages/leasing',
    '/pages/mengenrabatt', '/pages/impressum', '/pages/datenschutzerklarung', '/pages/agb', '/pages/widerufsformular',
    '/pages/newsletter'];

  var K = {
    dismissed: 'bmp_popup_dismissed_until', subscribed: 'bmp_popup_subscribed', amount: 'bmp_popup_wheel_amount',
    amountBusiness: 'bmp_popup_wheel_amount_b2b', pageviews: 'bmp_popup_pageviews', shown: 'bmp_popup_shown', session: 'bmp_popup_session_suppressed'
  };

  function warn(msg) { if (typeof console !== 'undefined') console.warn('[bmp-popup] ' + msg); }

  // ---- Pure helpers ----
  function defaultRand() {
    try {
      var c = root && root.crypto;
      if (c && c.getRandomValues) return c.getRandomValues(new Uint32Array(1))[0] / 4294967296;
    } catch (e) { /* fall through */ }
    return Math.random();
  }
  function randOf(rand) { return typeof rand === 'function' ? rand : defaultRand; }
  function mod(a, n) { return ((a % n) + n) % n; }

  // Every wheel helper takes an optional wheel (WHEELS.private when omitted).
  function wheelOf(wheel) { return wheel && wheel.segments ? wheel : WHEELS.private; }

  function drawAmount(rand, wheel) {
    var odds = wheelOf(wheel).odds, total = 0, i;
    for (i = 0; i < odds.length; i++) total += odds[i].weight;
    var r = randOf(rand)() * total;
    for (i = 0; i < odds.length; i++) {
      r -= odds[i].weight;
      if (r < 0) return odds[i].amount;
    }
    return odds[odds.length - 1].amount;
  }

  function pickSegmentIndex(amount, rand, wheel) {
    var segs = wheelOf(wheel).segments, idx = [];
    for (var i = 0; i < segs.length; i++) if (segs[i] === Number(amount)) idx.push(i);
    if (!idx.length) return -1;
    return idx[Math.min(idx.length - 1, Math.floor(randOf(rand)() * idx.length))];
  }

  function segDeg(wheel) { return 360 / wheelOf(wheel).segments.length; }

  // Segment under the fixed 12 o'clock pointer after rotating the rotor clockwise by rotationDeg.
  function segmentAtPointer(rotationDeg, wheel) {
    return Math.floor(mod(-rotationDeg, 360) / segDeg(wheel)) % wheelOf(wheel).segments.length;
  }

  // Rotation > current + 5 turns that puts a point inside segment i (>= EDGE_MARGIN from edges) under the pointer.
  function targetRotation(segmentIndex, currentRotation, rand, wheel) {
    var cur = Number(currentRotation) || 0, deg = segDeg(wheel);
    var angle = segmentIndex * deg + EDGE_MARGIN + randOf(rand)() * (deg - 2 * EDGE_MARGIN);
    var base = cur + 5 * 360;
    var r = base + mod(360 - angle - base, 360);
    if (r <= base) r += 360;
    return r;
  }

  // "5 €, 8 € und 10 €": distinct amounts, ascending.
  function wheelFieldsText(wheel) {
    var list = wheelOf(wheel).odds.map(function (o) { return o.amount; }).sort(function (x, y) { return x - y; })
      .map(function (n) { return n + NB + '€'; });
    return list.length > 1 ? list.slice(0, -1).join(', ') + COPY.fieldsAnd + list[list.length - 1] : list.join('');
  }

  function normalizePath(pathname) {
    var p = String(pathname == null ? '' : pathname).split(/[?#]/)[0].toLowerCase();
    try { p = decodeURI(p); } catch (e) { /* keep raw */ }
    p = ('/' + p).replace(/\/{2,}/g, '/');
    var seg = p.split('/');
    if (seg.length > 1 && /^[a-z]{2}(-[a-z]{2})?$/.test(seg[1])) { seg.splice(1, 1); p = seg.join('/') || '/'; }
    if (p.length > 1) p = p.replace(/\/+$/, '');
    return p || '/';
  }

  function parsePatterns(v) {
    var list = Array.isArray(v) ? v : typeof v === 'string' ? v.split(/[\n,]+/) : [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var s = String(list[i] == null ? '' : list[i]).trim();
      if (s) out.push(s);
    }
    return out;
  }

  function isExcludedPath(pathname, patterns) {
    var path = normalizePath(pathname);
    var list = parsePatterns(patterns);
    for (var i = 0; i < list.length; i++) {
      var raw = list[i].toLowerCase().replace(/^[a-z]+:\/\/[^/]+/, '');
      if (raw.charAt(0) !== '/') raw = '/' + raw;
      var loose = /[^/*]\*$/.test(raw); // e.g. /pages/b2b* = raw prefix
      var pre = raw.replace(/\*+$/, '').replace(/\/+$/, '') || '/';
      if (loose) { if (path.indexOf(pre) === 0) return true; continue; }
      if (pre === '/') { if (path === '/') return true; continue; }
      if (path === pre || path.indexOf(pre + '/') === 0) return true;
    }
    return false;
  }

  function parseQuery(search) {
    var out = {};
    String(search || '').replace(/^\?/, '').split('&').forEach(function (part) {
      if (!part) return;
      var i = part.indexOf('=');
      var k = i < 0 ? part : part.slice(0, i), v = i < 0 ? '' : part.slice(i + 1);
      try { k = decodeURIComponent(k.replace(/\+/g, ' ')); v = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (e) { /* raw */ }
      k = k.toLowerCase();
      if (!(k in out)) out[k] = v;
    });
    return out;
  }

  // First "no" wins. Returns { eligible, reason, suppressSession }.
  function evaluateSuppression(ctx) {
    ctx = ctx || {};
    var q = parseQuery(ctx.search);
    var now = ctx.now == null ? Date.now() : ctx.now;
    function no(reason, sess) { return { eligible: false, reason: reason, suppressSession: sess || null }; }
    if (ctx.enabled === false) return no('disabled');
    if (ctx.pathExcluded) return no('excluded');
    if (String(q.utm_medium || '').toLowerCase() === 'email') return no('utm_email', 'utm_email');
    if ('_kx' in q) return no('kx', 'kx');
    if (ctx.sessionSuppressed) return no('session_suppressed');
    if (ctx.subscribed) return no('subscribed');
    if (Number(ctx.dismissedUntil) > now) return no('dismissed');
    if (ctx.identified) return no('identified', 'identified');
    return { eligible: true, reason: 'eligible', suppressSession: null };
  }

  function b64decode(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    while (s.length % 4) s += '=';
    if (typeof atob === 'function') return atob(s);
    return Buffer.from(s, 'base64').toString('binary'); // eslint-disable-line no-undef
  }

  function decodeKlaId(cookieString) {
    var m = /(?:^|;\s*)__kla_id=([^;]*)/.exec(String(cookieString || ''));
    if (!m || !m[1]) return null;
    try {
      var obj = JSON.parse(b64decode(decodeURIComponent(m[1])));
      return obj && typeof obj === 'object' ? obj : null;
    } catch (e) { return null; }
  }

  function isKlaviyoIdentifiedCookie(cookieString) {
    var o = decodeKlaId(cookieString);
    if (!o) return false;
    var has = function (v) { return typeof v === 'string' ? v.trim() !== '' : !!v; };
    return has(o.$exchange_id) || has(o.$email);
  }

  function isValidEmail(s) {
    var v = String(s == null ? '' : s).trim();
    return v.length <= 254 && /^[^\s@"<>(),;:]+@[^\s@"<>(),;:.]+(\.[^\s@"<>(),;:.]+)*\.[^\s@"<>(),;:.\d]{2,}$/.test(v) && !/\.\./.test(v);
  }

  function derivePhoneHref(display) {
    var s = String(display == null ? '' : display).trim();
    if (!s) return '';
    var plus = s.charAt(0) === '+';
    var d = s.replace(/\D/g, '');
    if (!d) return '';
    if (plus) return 'tel:+' + d;
    if (d.indexOf('00') === 0) return 'tel:+' + d.slice(2);
    if (d.charAt(0) === '0') return 'tel:+49' + d.slice(1);
    return 'tel:+' + d;
  }

  function compact(obj) {
    var out = {};
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      var v = obj[k];
      if (v === undefined || v === null || (typeof v === 'string' && v.trim() === '')) continue;
      out[k] = v;
    }
    return out;
  }

  function normEmail(e) { return String(e == null ? '' : e).trim().toLowerCase(); }

  function buildPayload(email, props, listId) {
    var data = {
      type: 'subscription',
      attributes: {
        custom_source: CUSTOM_SOURCE,
        profile: { data: { type: 'profile', attributes: {
          email: normEmail(email),
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          properties: compact(props)
        } } }
      }
    };
    var list = String(listId == null ? '' : listId).trim();
    if (list) data.relationships = { list: { data: { type: 'list', id: list } } };
    return { data: data };
  }

  function buildPrivatePayload(o) {
    o = o || {};
    return buildPayload(o.email, { kundentyp: 'Privatperson', gluecksrad_betrag: Number(o.amount), optin_quelle: 'popup_gluecksrad' }, o.listId);
  }

  var SEATS = ['1-4', '5-19', '20+'];
  function buildBusinessPayload(o) {
    o = o || {};
    var seats = String(o.seats == null ? '' : o.seats).trim();
    var amount = Number(o.amount);
    return buildPayload(o.email, {
      kundentyp: 'Unternehmen',
      gluecksrad_betrag: isFinite(amount) && amount > 0 ? amount : null,
      optin_quelle: 'popup_b2b_gluecksrad',
      firma: String(o.company == null ? '' : o.company).trim(),
      arbeitsplaetze: SEATS.indexOf(seats) >= 0 ? seats : ''
    }, o.listId);
  }

  function buildKlaviyoRequest(publicKey, payload) {
    return {
      url: KLAVIYO_URL + '?company_id=' + encodeURIComponent(String(publicKey || '').trim()),
      init: {
        method: 'POST',
        headers: { revision: KLAVIYO_REVISION, 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json' },
        body: JSON.stringify(payload)
      }
    };
  }

  // Single network call. Resolves { ok, status } and never rejects.
  function sendSubscription(payload, opts) {
    opts = opts || {};
    var f = opts.fetch || (typeof fetch === 'function' ? fetch : null);
    if (!f) return Promise.resolve({ ok: false, status: 'network' });
    var req = buildKlaviyoRequest(opts.publicKey, payload);
    var AC = opts.AbortController || (typeof AbortController === 'function' ? AbortController : null);
    var ctrl = AC ? new AC() : null;
    var timedOut = false;
    if (ctrl) req.init.signal = ctrl.signal;
    return new Promise(function (resolve) {
      var t = setTimeout(function () {
        timedOut = true;
        if (ctrl) ctrl.abort();
        resolve({ ok: false, status: 'timeout' });
      }, opts.timeoutMs || 10000);
      Promise.resolve().then(function () { return f(req.url, req.init); }).then(function (res) {
        clearTimeout(t);
        if (!timedOut) resolve({ ok: res.status >= 200 && res.status < 300, status: res.status });
      }, function () {
        clearTimeout(t);
        if (!timedOut) resolve({ ok: false, status: 'network' });
      });
    });
  }

  function str(v, d) { return typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : (d || ''); }
  function bool(v, d) { return typeof v === 'boolean' ? v : v === 'true' ? true : v === 'false' ? false : d; }
  function num(v, d, min, max) {
    var n = typeof v === 'number' ? v : typeof v === 'string' && v.trim() !== '' ? Number(v) : NaN;
    if (!isFinite(n)) return d;
    return Math.min(max, Math.max(min, n));
  }

  function cssUrlFrom(src) {
    if (!src) return 'bmp-newsletter-popup.css';
    return String(src).replace(/[^/?#]*([?#].*)?$/, 'bmp-newsletter-popup.css');
  }

  function parseConfig(rawJson, scriptSrc) {
    var src = {};
    if (rawJson && typeof rawJson === 'object') src = rawJson;
    else if (typeof rawJson === 'string' && rawJson.trim()) {
      try {
        var p = JSON.parse(rawJson);
        if (p && typeof p === 'object' && !Array.isArray(p)) src = p;
        else warn('Config is not an object, using defaults.');
      } catch (e) { warn('Invalid config JSON, using defaults.'); }
    }
    var depth = num(src.scrollDepth, 0.4, 0, 100);
    if (depth > 1) depth = depth / 100;
    var excluded = parsePatterns(src.excludedPaths);
    var c = {
      enabled: bool(src.enabled, true),
      mode: src.mode === 'demo' ? 'demo' : 'live',
      demoOutcome: src.demoOutcome === 'error' ? 'error' : 'success',
      klaviyoPublicKey: str(src.klaviyoPublicKey),
      klaviyoListId: str(src.klaviyoListId),
      cssUrl: str(src.cssUrl) || cssUrlFrom(scriptSrc),
      logoUrl: str(src.logoUrl),
      logoAlt: str(src.logoAlt) || 'Büromöbel Plus',
      privacyUrl: str(src.privacyUrl) || '/policies/privacy-policy',
      phoneDisplay: str(src.phoneDisplay) || '0365 4303 9684',
      phoneHref: '',
      delaySeconds: num(src.delaySeconds, 15, 0, 3600),
      scrollDepth: Math.min(1, depth),
      exitIntent: bool(src.exitIntent, true),
      mobileBreakpoint: num(src.mobileBreakpoint, 768, 0, 10000),
      mobileMinPageviews: num(src.mobileMinPageviews, 2, 1, 1000),
      suppressDays: num(src.suppressDays, 7, 0, 3650),
      excludedPaths: excluded.length ? excluded : DEFAULT_EXCLUDED.slice(),
      sectionId: str(src.sectionId),
      designMode: bool(src.designMode, false),
      debug: bool(src.debug, false)
    };
    c.phoneHref = str(src.phoneHref) || derivePhoneHref(c.phoneDisplay);
    return c;
  }

  var internals = {
    WHEELS: WHEELS, WHEEL_ODDS: WHEEL_ODDS, WHEEL_SEGMENTS: WHEEL_SEGMENTS, SPIN_MS: SPIN_MS, WIN_PAUSE_MS: WIN_PAUSE_MS,
    KLAVIYO_REVISION: KLAVIYO_REVISION, wheelFieldsText: wheelFieldsText,
    CUSTOM_SOURCE: CUSTOM_SOURCE, KLAVIYO_URL: KLAVIYO_URL, EDGE_MARGIN: EDGE_MARGIN, COPY: COPY,
    DEFAULT_EXCLUDED: DEFAULT_EXCLUDED, STORAGE_KEYS: K, VERSION: VERSION,
    parseConfig: parseConfig, drawAmount: drawAmount, pickSegmentIndex: pickSegmentIndex,
    targetRotation: targetRotation, segmentAtPointer: segmentAtPointer, normalizePath: normalizePath,
    isExcludedPath: isExcludedPath, parseQuery: parseQuery, evaluateSuppression: evaluateSuppression,
    decodeKlaId: decodeKlaId, isKlaviyoIdentifiedCookie: isKlaviyoIdentifiedCookie,
    buildPrivatePayload: buildPrivatePayload, buildBusinessPayload: buildBusinessPayload,
    buildKlaviyoRequest: buildKlaviyoRequest, sendSubscription: sendSubscription,
    isValidEmail: isValidEmail, derivePhoneHref: derivePhoneHref, cssUrlFrom: cssUrlFrom
  };

  // ---- Browser runtime ----
  function boot() {
    var w = window, doc = document;
    if (w.BMPNewsletterPopup) return;

    var cfgEl = doc.getElementById('bmp-popup-config');
    var cfg = parseConfig(cfgEl ? cfgEl.textContent : null, currentScript && currentScript.src);
    var query = parseQuery(w.location.search);
    var qa = String(query.bmp_popup || '').toLowerCase();
    var state = {
      eligible: false, reason: 'init', isMobile: false, step: null, open: false,
      rotation: { private: 0, business: 0 }, spinning: false, spinId: 0, gen: 0, busy: false, lastFocus: null,
      amounts: { private: null, business: null }, subscribed: false
    };
    var els = null, teaser = null, cssPromise = null, openPromise = null;
    var TRIGGER_RETRY_MS = 5000;

    function log() {
      if (!cfg.debug || typeof console === 'undefined') return;
      console.info.apply(console, ['[bmp-popup]'].concat([].slice.call(arguments)));
    }
    function emit(name, detail) {
      log('event', name, detail);
      try { doc.dispatchEvent(new CustomEvent('bmp-popup:' + name, { detail: detail })); } catch (e) { /* old browser */ }
    }
    function store(kind) {
      try { return kind === 's' ? w.sessionStorage : w.localStorage; } catch (e) { return null; }
    }
    function sGet(kind, key) {
      try { var s = store(kind); return s ? s.getItem(key) : null; } catch (e) { return null; }
    }
    function sSet(kind, key, val) {
      if (cfg.designMode) return;
      try { var s = store(kind); if (s) s.setItem(key, String(val)); } catch (e) { /* ignore */ }
    }
    function clearStorage() {
      ['l', 's'].forEach(function (kind) {
        try {
          var s = store(kind);
          if (!s) return;
          for (var i = s.length - 1; i >= 0; i--) {
            var key = s.key(i);
            if (key && key.indexOf('bmp_popup_') === 0) s.removeItem(key);
          }
        } catch (e) { /* ignore */ }
      });
    }
    function isSubscribed() { return state.subscribed || !!sGet('l', K.subscribed); }
    function dismissedUntil() { var n = Number(sGet('l', K.dismissed)); return isFinite(n) && n > 0 ? n : 0; }
    function amountKey(kind) { return kind === 'business' ? K.amountBusiness : K.amount; }
    function storedAmount(kind) {
      var n = Number(sGet('l', amountKey(kind))), odds = WHEELS[kind].odds;
      for (var i = 0; i < odds.length; i++) if (odds[i].amount === n) return n;
      return null;
    }
    function reducedMotion() {
      try { return w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
    }

    // ---- Lazy CSS ----
    function ensureCss() {
      if (cssPromise) return cssPromise;
      cssPromise = new Promise(function (resolve) {
        if (!cfg.cssUrl || doc.querySelector('link[data-bmp-css]')) return resolve();
        var link = doc.createElement('link');
        link.rel = 'stylesheet';
        link.href = cfg.cssUrl;
        link.setAttribute('data-bmp-css', '');
        var done = function () { resolve(); };
        link.onload = done;
        link.onerror = function () { warn('Could not load ' + cfg.cssUrl); resolve(); };
        setTimeout(done, 2000);
        (doc.head || doc.documentElement).appendChild(link);
      });
      return cssPromise;
    }

    // ---- DOM ----
    function safeUrl(u) { return /^\s*(javascript|data|vbscript):/i.test(u) ? '#' : u; }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    function icon(paths, size) {
      return '<svg class="bmp-icon" viewBox="0 0 24 24" width="' + size + '" height="' + size + '" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
    }
    var ICON_CLOSE = icon('<path d="M6 6l12 12M18 6L6 18"/>', 20);
    var ICON_HOME = icon('<path d="M3.5 11L12 4l8.5 7"/><path d="M6 9.5v10h12v-10"/><path d="M10 19.5v-5.5h4v5.5"/>', 30);
    var ICON_BIZ = icon('<path d="M3.5 20h17"/><path d="M5.5 20V4.5h8.5V20"/><path d="M14 9h4.5v11"/><path d="M8.5 8h3M8.5 11.5h3M8.5 15h3M16 12.5h.5M16 16h.5"/>', 30);

    var ICON_CHECK = icon('<path d="M5 12.5l4.5 4.5L19 7.5"/>', 18);

    function wheelSvg(kind) {
      var wheel = WHEELS[kind], segs = wheel.segments, deg = segDeg(wheel);
      var cx = 100, cy = 106, R = 88, parts = [], rings = [], labels = [], lines = [];
      function pt(a, r) {
        var rad = a * Math.PI / 180;
        return (cx + r * Math.sin(rad)).toFixed(2) + ' ' + (cy - r * Math.cos(rad)).toFixed(2);
      }
      function sector(a0, a1, r) {
        return 'M' + cx + ' ' + cy + 'L' + pt(a0, r) + 'A' + r + ' ' + r + ' 0 ' + (a1 - a0 > 180 ? 1 : 0) + ' 1 ' + pt(a1, r) + 'Z';
      }
      for (var i = 0; i < segs.length; i++) {
        var a0 = i * deg, a1 = a0 + deg, mid = a0 + deg / 2;
        parts.push('<path class="bmp-seg" data-bmp-seg="' + i + '" d="' + sector(a0, a1, R) + '" fill="' + (i % 2 ? '#FFFFFF' : '#FFB74A') + '"/>');
        // win outline sits just inside the rim, so the rim stroke never covers it
        rings.push('<path class="bmp-seg-ring" data-bmp-seg="' + i + '" d="' + sector(a0, a1, R - 2) + '"/>');
        lines.push('<path d="M' + cx + ' ' + cy + 'L' + pt(a0, R) + '"/>');
        var p = pt(mid, R * 0.62).split(' ');
        // label 'up' points outward, so the winning label reads upright under the pointer
        labels.push('<text data-bmp-seg="' + i + '" x="' + p[0] + '" y="' + p[1] + '" transform="rotate(' + mid + ' ' + p[0] + ' ' + p[1] + ')">' + segs[i] + NB + '€</text>');
      }
      return '<svg class="bmp-wheel" data-bmp-wheel="' + kind + '" role="img" aria-label="' + esc(COPY.wheelLabel.replace('{felder}', wheelFieldsText(wheel))) + '" viewBox="0 0 200 200" width="264" height="264" focusable="false">' +
        '<g data-bmp-wheel-rotor class="bmp-wheel__rotor" style="transform-box:fill-box;transform-origin:center">' + parts.join('') +
        '<g stroke="#E3E3E3" stroke-width="1">' + lines.join('') + '</g>' +
        '<g class="bmp-wheel__labels" fill="#1A1A1A" font-size="15" font-weight="600" text-anchor="middle" dominant-baseline="central">' + labels.join('') + '</g>' +
        '<g class="bmp-wheel__rings" fill="none" stroke="#FF5C39" stroke-width="3.5" stroke-linejoin="round">' + rings.join('') + '</g></g>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + R + '" fill="none" stroke="#E3E3E3" stroke-width="2"/>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="13" fill="#FFFFFF" stroke="#E3E3E3" stroke-width="1.5"/>' +
        '<path d="M91 5h18l-9 21z" fill="#FF5C39" stroke="#FFFFFF" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    }
    function wheelPanel(kind) {
      return '<div class="bmp-panel bmp-wheel-panel" data-bmp-wheel-panel="' + kind + '" hidden>' + wheelSvg(kind) +
        '<p class="bmp-fine">' + esc(COPY.finePrint) + '</p></div>';
    }

    function field(form, name, label, type, extra) {
      var id = 'bmp-' + form + '-' + name;
      return '<div class="bmp-field"><label class="bmp-label" for="' + id + '">' + esc(label) + '</label>' +
        '<input class="bmp-input" id="' + id + '" name="' + name + '" type="' + type + '" ' + (extra || '') + '>' +
        '<p class="bmp-field-error" id="' + id + '-error" hidden></p></div>';
    }
    function consent(form) {
      var id = 'bmp-' + form + '-consent';
      return '<div class="bmp-field bmp-field--check"><label class="bmp-check" for="' + id + '">' +
        '<input class="bmp-checkbox" id="' + id + '" name="consent" type="checkbox" value="1">' +
        '<span class="bmp-check__text">' + esc(COPY.consentPre) + '<a class="bmp-link" href="' + esc(safeUrl(cfg.privacyUrl)) + '" target="_blank" rel="noopener">' +
        esc(COPY.consentLink) + '</a>' + esc(COPY.consentPost) + '</span></label>' +
        '<p class="bmp-field-error" id="' + id + '-error" hidden></p></div>';
    }
    function honeypot() {
      return '<div class="bmp-hp" aria-hidden="true"><label>Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label></div>';
    }
    function title(step, text) {
      return '<h2 class="bmp-title" id="bmp-popup-title-' + step + '" tabindex="-1">' + text + '</h2>';
    }
    function submitBtn(text) {
      return '<div class="bmp-error" data-bmp-error role="alert"></div><button type="submit" class="bmp-btn bmp-btn--primary">' + esc(text) + '</button>';
    }

    // "{betrag} €" in a heading becomes the highlighted amount; showAmount() fills the number per customer type.
    function amountTitle(template, kind, attr) {
      return esc(template).replace('{betrag}' + NB + '€', '<span class="bmp-amount"><span ' + attr + '="' + kind + '">10</span>' + NB + '€</span>');
    }
    function spinButtons() {
      return '<button type="button" class="bmp-btn bmp-btn--primary" data-bmp-action="spin">' + esc(COPY.spin) + '</button>' +
        '<button type="button" class="bmp-decline" data-bmp-action="decline">' + esc(COPY.decline) + '</button>';
    }
    function businessStepsHtml() {
      var seatOpts = COPY.seatsOptions.map(function (o) { return '<option value="' + o[0] + '">' + esc(o[1]) + '</option>'; }).join('');
      var perks = COPY.businessPerks.map(function (t) { return '<li class="bmp-perk">' + ICON_CHECK + '<span>' + esc(t) + '</span></li>'; }).join('');
      var contact = '<p class="bmp-text">' + esc(COPY.businessDoneContact) + '<a class="bmp-link bmp-phone" href="' + esc(safeUrl(cfg.phoneHref)) + '">' + esc(cfg.phoneDisplay).replace(/ /g, NB) + '</a></p>';
      return '<div class="bmp-step" data-bmp-step="business" hidden>' + title('business', esc(COPY.businessTitle)) +
          '<p class="bmp-text">' + esc(COPY.businessText) + '</p>' +
          '<p class="bmp-perks__lead" id="bmp-perks-lead">' + esc(COPY.businessPerksLead) + '</p>' +
          '<ul class="bmp-perks" aria-labelledby="bmp-perks-lead">' + perks + '</ul>' + spinButtons() + '</div>' +
        '<div class="bmp-step" data-bmp-step="business-claim" hidden>' +
          title('business-claim', amountTitle(COPY.claimTitle, 'business', 'data-bmp-claim-amount')) +
          '<p class="bmp-text">' + esc(COPY.claimText) + '</p>' +
          '<form class="bmp-form" data-bmp-form="business" novalidate>' +
          field('business', 'email', COPY.emailLabel, 'email', 'autocomplete="email" inputmode="email" required') +
          field('business', 'company', COPY.companyLabel, 'text', 'autocomplete="organization"') +
          '<div class="bmp-field"><label class="bmp-label" for="bmp-business-seats">' + esc(COPY.seatsLabel) + '</label>' +
          '<select class="bmp-input bmp-select" id="bmp-business-seats" name="seats">' + seatOpts + '</select></div>' +
          consent('business') + honeypot() + submitBtn(COPY.claimSubmit) + '</form>' +
          '<button type="button" class="bmp-decline" data-bmp-action="decline">' + esc(COPY.decline) + '</button></div>' +
        '<div class="bmp-step" data-bmp-step="business-done" hidden>' +
          title('business-done', amountTitle(COPY.privateDoneTitle, 'business', 'data-bmp-amount')) +
          '<p class="bmp-text">' + esc(COPY.businessDoneText) + '</p>' + contact +
          '<button type="button" class="bmp-btn bmp-btn--primary" data-bmp-action="done">' + esc(COPY.privateDoneButton) + '</button></div>';
    }

    function buildDialog() {
      var logo = cfg.logoUrl
        ? '<img class="bmp-logo" src="' + esc(safeUrl(cfg.logoUrl)) + '" alt="' + esc(cfg.logoAlt) + '" width="941" height="120" decoding="async">'
        : '<span class="bmp-wordmark" aria-label="' + esc(cfg.logoAlt) + '">Büromöbel<span aria-hidden="true">+</span></span>';
      var html =
        '<button type="button" class="bmp-close" data-bmp-action="close" aria-label="' + esc(COPY.close) + '">' + ICON_CLOSE + '</button>' +
        '<div class="bmp-scroll">' +
        '<div class="bmp-head" data-bmp-logo>' + logo + '</div>' +
        wheelPanel('private') + wheelPanel('business') +
        '<div class="bmp-steps">' +
        '<div class="bmp-step" data-bmp-step="choose">' + title('choose', esc(COPY.chooseTitle)) +
          '<p class="bmp-text">' + esc(COPY.chooseText) + '</p><div class="bmp-choices">' +
          '<button type="button" class="bmp-choice" data-bmp-action="choose-private">' + ICON_HOME + '<span>' + esc(COPY.choosePrivate) + '</span></button>' +
          '<button type="button" class="bmp-choice" data-bmp-action="choose-business">' + ICON_BIZ + '<span>' + esc(COPY.chooseBusiness) + '</span></button></div></div>' +
        '<div class="bmp-step" data-bmp-step="private" hidden>' + title('private', esc(COPY.privateTitle)) +
          '<p class="bmp-text">' + esc(COPY.privateText) + '</p>' + spinButtons() + '</div>' +
        '<div class="bmp-step" data-bmp-step="private-claim" hidden>' +
          title('private-claim', amountTitle(COPY.claimTitle, 'private', 'data-bmp-claim-amount')) +
          '<p class="bmp-text">' + esc(COPY.claimText) + '</p>' +
          '<form class="bmp-form" data-bmp-form="private" novalidate>' +
          field('private', 'email', COPY.emailLabel, 'email', 'autocomplete="email" inputmode="email" required') +
          consent('private') + honeypot() + submitBtn(COPY.claimSubmit) + '</form>' +
          '<button type="button" class="bmp-decline" data-bmp-action="decline">' + esc(COPY.decline) + '</button></div>' +
        '<div class="bmp-step" data-bmp-step="private-done" hidden>' +
          title('private-done', amountTitle(COPY.privateDoneTitle, 'private', 'data-bmp-amount')) +
          '<p class="bmp-text">' + esc(COPY.privateDoneText) + '</p>' +
          '<button type="button" class="bmp-btn bmp-btn--primary" data-bmp-action="done">' + esc(COPY.privateDoneButton) + '</button></div>' +
        businessStepsHtml() +
        '</div></div>' +
        '<div class="bmp-sr" data-bmp-live aria-live="polite"></div>';

      var d = doc.createElement('dialog');
      d.className = 'bmp-popup';
      d.id = 'bmp-popup';
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      d.innerHTML = html;
      doc.body.appendChild(d);

      var q = function (sel) { return d.querySelector(sel); };
      els = {
        dialog: d,
        panels: { private: q('[data-bmp-wheel-panel="private"]'), business: q('[data-bmp-wheel-panel="business"]') },
        wheels: { private: q('[data-bmp-wheel="private"]'), business: q('[data-bmp-wheel="business"]') },
        rotors: { private: q('[data-bmp-wheel="private"] [data-bmp-wheel-rotor]'), business: q('[data-bmp-wheel="business"] [data-bmp-wheel-rotor]') },
        steps: { private: q('[data-bmp-step="private"]'), business: q('[data-bmp-step="business"]') },
        live: q('[data-bmp-live]'),
        forms: { private: q('[data-bmp-form="private"]'), business: q('[data-bmp-form="business"]') }
      };
      KINDS.forEach(function (k) { els.rotors[k].style.transform = 'rotate(' + state.rotation[k] + 'deg)'; });

      d.addEventListener('click', onClick);
      d.addEventListener('mousedown', function (e) { state.downOnBackdrop = isBackdropHit(e); });
      d.addEventListener('submit', onSubmit);
      d.addEventListener('input', onFieldInput);
      d.addEventListener('change', onFieldInput);
      d.addEventListener('keydown', onKeydown);
      d.addEventListener('cancel', function (e) { e.preventDefault(); close('escape'); });
      // The native close event arrives a task later. After close() plus an immediate re-open (theme editor
      // re-render, scripted demo runs) it must not close the bookkeeping of the dialog that is open again.
      d.addEventListener('close', function () { if (els && els.dialog === d && !d.open) finishClose('escape'); });
    }

    function isBackdropHit(e) {
      if (e.target !== els.dialog) return false;
      var r = els.dialog.getBoundingClientRect();
      return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    }

    // ---- Steps ----
    var KINDS = ['private', 'business'];
    function kindOf(step) { return /^private/.test(step || '') ? 'private' : /^business/.test(step || '') ? 'business' : null; }

    function setStep(step, quiet) {
      if (!els) return;
      // returning visitor: that wheel already stopped on an amount, so never offer a second spin
      if ((step === 'private' || step === 'business') && !state.spinning) {
        var amount = currentAmount(step);
        if (amount != null) {
          restWheel(step, amount);
          showAmount(step, amount);
          step = step + '-claim';
        }
      }
      state.step = step;
      var d = els.dialog;
      [].forEach.call(d.querySelectorAll('[data-bmp-step]'), function (el) {
        el.hidden = el.getAttribute('data-bmp-step') !== step;
      });
      d.setAttribute('data-bmp-current-step', step);
      d.setAttribute('aria-labelledby', 'bmp-popup-title-' + step);
      updatePanels();
      var sc = d.querySelector('.bmp-scroll');
      if (sc) sc.scrollTop = 0;
      if (!quiet) emit('step', { step: step });
      if (state.open) focusHeading();
    }
    // Left column (desktop) / top area (mobile): the wheel of the current customer type.
    function updatePanels() {
      if (!els) return;
      var kind = kindOf(state.step);
      KINDS.forEach(function (k) { els.panels[k].hidden = k !== kind; });
      if (kind) els.dialog.setAttribute('data-bmp-split', 'wheel');
      else els.dialog.removeAttribute('data-bmp-split');
    }
    function focusHeading() {
      var h = els && els.dialog.querySelector('#bmp-popup-title-' + state.step);
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    function announce(text) {
      if (!els) return;
      els.live.textContent = '';
      setTimeout(function () { els.live.textContent = text; }, 50);
    }

    function resetForms() {
      ['private', 'business'].forEach(function (k) {
        var f = els.forms[k];
        f.reset();
        clearErrors(f);
        setBusy(f, false);
      });
      KINDS.forEach(function (k) { submitLabel(els.forms[k], COPY.claimSubmit); });
    }
    function submitLabel(form, text) { form.querySelector('[type="submit"]').textContent = text; }

    // ---- Open / close ----
    var OPEN_STEPS = ['choose', 'private', 'business'];
    // options.step opens that step directly ('private' lands on 'private-claim' once an amount exists).
    function open(reason, options) {
      reason = reason || 'api';
      var step = options && OPEN_STEPS.indexOf(options.step) >= 0 ? options.step : 'choose';
      if (state.open) {
        if (options && options.step && !state.busy && state.step !== step) setStep(step);
        return Promise.resolve();
      }
      if (openPromise) return openPromise;
      state.lastFocus = doc.activeElement;
      hideTeaser();
      openPromise = ensureCss().then(function () {
        if (!els) buildDialog();
        resetForms();
        setStep(step);
        var d = els.dialog;
        try { if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); }
        catch (e) { d.setAttribute('open', ''); }
        state.open = true;
        focusHeading();
        emit('open', { reason: reason });
      }).then(function () { openPromise = null; }, function (e) { openPromise = null; warn(e && e.message); });
      return openPromise;
    }

    function close(reason) {
      // also closes a dialog whose bookkeeping already ran (defensive, see the close listener)
      if (!state.open && !(els && els.dialog.open)) return;
      try { if (els.dialog.open) els.dialog.close(); } catch (e) { els.dialog.removeAttribute('open'); }
      finishClose(reason || 'api');
    }

    // Idempotent close bookkeeping (also runs when the browser closes the dialog natively).
    function finishClose(reason) {
      if (!state.open) return;
      state.open = false;
      if (!isSubscribed() && !cfg.designMode) {
        sSet('l', K.dismissed, Date.now() + cfg.suppressDays * 86400000);
        removeTeaser();
      }
      var f = state.lastFocus;
      state.lastFocus = null;
      if (f && f !== doc.body && typeof f.focus === 'function' && doc.documentElement.contains(f)) {
        try { f.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      emit('close', { reason: reason });
    }

    // ---- Events inside the dialog ----
    function onClick(e) {
      if (isBackdropHit(e)) {
        if (state.downOnBackdrop !== false) close('backdrop');
        return;
      }
      var btn = e.target.closest ? e.target.closest('[data-bmp-action]') : null;
      if (!btn || btn.disabled) return;
      var a = btn.getAttribute('data-bmp-action');
      if (a === 'close') close('close-button');
      else if (a === 'decline') close('decline');
      else if (a === 'done') close('done');
      else if (a === 'choose-private') setStep('private');
      else if (a === 'choose-business') setStep('business');
      else if (a === 'spin') spin(kindOf(state.step));
    }

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var list = [].filter.call(els.dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]'), function (el) {
        return el.tabIndex >= 0 && !el.disabled && !el.closest('[hidden]') && el.getClientRects().length > 0;
      });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1], act = doc.activeElement;
      var out = !els.dialog.contains(act);
      if (e.shiftKey && (act === first || out)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (act === last || out)) { e.preventDefault(); first.focus(); }
    }

    function onFieldInput(e) {
      var t = e.target;
      if (t && t.getAttribute && t.getAttribute('aria-invalid') === 'true') setFieldError(t, '');
    }

    function setFieldError(input, msg) {
      var err = doc.getElementById(input.id + '-error');
      if (msg) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', input.id + '-error');
        if (err) { err.textContent = msg; err.hidden = false; }
      } else {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (err) { err.textContent = ''; err.hidden = true; }
      }
    }
    function clearErrors(form) {
      [].forEach.call(form.querySelectorAll('[aria-invalid]'), function (el) { setFieldError(el, ''); });
      formError(form, '');
    }
    function formError(form, msg) { form.querySelector('[data-bmp-error]').textContent = msg; }

    function validate(form) {
      var email = form.elements.email, ok = true, firstBad = null;
      clearErrors(form);
      if (!isValidEmail(email.value)) { setFieldError(email, COPY.errorEmail); ok = false; firstBad = email; }
      if (!form.elements.consent.checked) {
        setFieldError(form.elements.consent, COPY.errorConsent);
        ok = false;
        firstBad = firstBad || form.elements.consent;
      }
      if (firstBad) firstBad.focus();
      return ok;
    }

    function setBusy(form, on) {
      var step = form.closest('[data-bmp-step]');
      [].forEach.call(step.querySelectorAll('input:not([name="website"]), select, button'), function (el) { el.disabled = on; });
      if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
    }

    function onSubmit(e) {
      e.preventDefault();
      var form = e.target;
      if (state.busy || !form || !form.getAttribute) return;
      var kind = form.getAttribute('data-bmp-form');
      if (!validate(form)) return;
      if (kind === 'private' || kind === 'business') submitClaim(kind, form);
    }

    // In-memory amount first (also covers the theme editor, which never writes storage), then storage.
    function currentAmount(kind) {
      return state.amounts[kind] != null ? state.amounts[kind] : storedAmount(kind);
    }
    function wheelAmount(kind) {
      var a = currentAmount(kind);
      if (a == null) a = drawAmount(null, WHEELS[kind]);
      sSet('l', amountKey(kind), a);
      state.amounts[kind] = a;
      return a;
    }
    function showAmount(kind, amount) {
      [].forEach.call(els.dialog.querySelectorAll('[data-bmp-claim-amount="' + kind + '"],[data-bmp-amount="' + kind + '"]'), function (el) {
        el.textContent = String(amount);
      });
    }
    function setRotor(kind, deg) {
      state.rotation[kind] = deg;
      els.rotors[kind].style.transition = 'none';
      els.rotors[kind].style.transform = 'rotate(' + deg + 'deg)';
    }
    // Puts the wheel on the amount without animation (unless it already rests on it) and highlights it.
    function restWheel(kind, amount) {
      var wheel = WHEELS[kind];
      if (wheel.segments[segmentAtPointer(state.rotation[kind], wheel)] !== Number(amount)) {
        setRotor(kind, mod(targetRotation(pickSegmentIndex(amount, null, wheel), 0, null, wheel), 360));
      }
      markWin(kind);
    }
    // Win highlight: orange outline on the field under the pointer, the other fields dimmed (CSS).
    function markWin(kind) {
      var svg = els.wheels[kind];
      var idx = String(segmentAtPointer(state.rotation[kind], WHEELS[kind]));
      svg.setAttribute('data-bmp-win', idx);
      [].forEach.call(svg.querySelectorAll('[data-bmp-seg]'), function (el) {
        el.classList.toggle('is-win', el.getAttribute('data-bmp-seg') === idx);
      });
    }
    function clearWin(kind) {
      var svg = els.wheels[kind];
      svg.removeAttribute('data-bmp-win');
      [].forEach.call(svg.querySelectorAll('.is-win'), function (el) { el.classList.remove('is-win'); });
    }

    function spin(kind) {
      if (!kind || state.busy || state.spinning || state.step !== kind) return; // double clicks never spin twice
      var gen = state.gen;
      var amount = wheelAmount(kind); // stored right away, so a reload mid-spin keeps the result
      var stepEl = els.steps[kind];
      state.spinning = true;
      setStepDisabled(stepEl, true);
      clearWin(kind);
      emit('spin', { kind: kind, amount: amount });
      spinTo(kind, amount).then(function () {
        if (gen !== state.gen) return; // reset() while spinning
        markWin(kind);
        showAmount(kind, amount);
        announce(COPY.result.replace('{betrag}', amount));
        // the highlighted win stays in view briefly before the form replaces the button
        setTimeout(function () {
          if (gen !== state.gen) return;
          state.spinning = false;
          setStepDisabled(stepEl, false);
          if (state.step === kind) setStep(kind + '-claim');
        }, reducedMotion() ? 0 : WIN_PAUSE_MS);
      });
    }
    function setStepDisabled(step, on) {
      [].forEach.call(step.querySelectorAll('button, input, select'), function (el) { el.disabled = on; });
    }

    function spinTo(kind, amount) {
      return new Promise(function (resolve) {
        var rotor = els.rotors[kind], wheel = WHEELS[kind];
        var target = targetRotation(pickSegmentIndex(amount, null, wheel), state.rotation[kind], null, wheel);
        var id = ++state.spinId;
        state.rotation[kind] = target;
        var finished = false;
        var finish = function () {
          if (finished) return;
          finished = true;
          rotor.removeEventListener('transitionend', onEnd);
          if (id === state.spinId) resolve();
        };
        var onEnd = function (ev) { if (ev.target === rotor) finish(); };
        announce(COPY.spinning);
        if (reducedMotion()) {
          rotor.style.transition = 'none';
          rotor.style.transform = 'rotate(' + target + 'deg)';
          return finish();
        }
        rotor.addEventListener('transitionend', onEnd);
        rotor.style.transition = 'transform ' + SPIN_MS + 'ms cubic-bezier(.17,.67,.12,1)';
        void rotor.getBoundingClientRect();
        rotor.style.transform = 'rotate(' + target + 'deg)';
        setTimeout(finish, SPIN_MS + 250);
      });
    }

    function send(kind, payload, amount) {
      emit('submit', { kind: kind, payload: payload, mode: cfg.mode });
      var p;
      if (cfg.mode === 'demo') {
        p = new Promise(function (resolve) {
          setTimeout(function () {
            resolve(cfg.demoOutcome === 'error' ? { ok: false, status: 500 } : { ok: true, status: 202 });
          }, 600);
        });
      } else if (!cfg.klaviyoPublicKey || !cfg.klaviyoListId) {
        console.error('[bmp-popup] Missing setting: ' + (!cfg.klaviyoPublicKey ? 'klaviyoPublicKey' : 'klaviyoListId'));
        p = Promise.resolve({ ok: false, status: 'config' });
      } else {
        p = sendSubscription(payload, { publicKey: cfg.klaviyoPublicKey });
      }
      var gen = state.gen;
      return p.then(function (res) {
        if (gen !== state.gen) return { ok: false, stale: true }; // reset() meanwhile: forget this result
        if (res.ok) {
          state.subscribed = true;
          sSet('l', K.subscribed, JSON.stringify({ kind: kind, ts: Date.now() }));
          removeTeaser();
          emit('success', { kind: kind, amount: amount });
        } else {
          emit('error', { kind: kind, status: res.status });
        }
        return res;
      });
    }

    // The wheel has already stopped: send the same amount (also on retry), never spin again.
    function submitClaim(kind, form) {
      var f = form.elements;
      var amount = wheelAmount(kind);
      var gen = state.gen;
      var payload = kind === 'business'
        ? buildBusinessPayload({ email: f.email.value, company: f.company.value, seats: f.seats.value, amount: amount, listId: cfg.klaviyoListId })
        : buildPrivatePayload({ email: f.email.value, amount: amount, listId: cfg.klaviyoListId });
      state.busy = true;
      setBusy(form, true);
      (f.website.value ? Promise.resolve({ ok: true, fake: true }) : send(kind, payload, amount)).then(function (res) {
        if (gen !== state.gen) return;
        state.busy = false;
        setBusy(form, false);
        if (res.ok) {
          showAmount(kind, amount);
          if (state.step === kind + '-claim') setStep(kind + '-done');
        } else {
          formError(form, COPY.errorSend);
          submitLabel(form, COPY.retry);
        }
      });
    }

    // ---- Mobile teaser ----
    function showTeaser() {
      if (teaser) return;
      ensureCss().then(function () {
        if (teaser || state.open || isSubscribed()) return;
        teaser = doc.createElement('div');
        teaser.className = 'bmp-teaser';
        teaser.setAttribute('data-bmp-teaser', '');
        teaser.innerHTML = '<button type="button" class="bmp-teaser__open" data-bmp-action="open-from-teaser">' + esc(COPY.teaser) + '</button>' +
          '<button type="button" class="bmp-teaser__close" data-bmp-action="dismiss-teaser" aria-label="' + esc(COPY.teaserClose) + '">' + icon('<path d="M7 7l10 10M17 7L7 17"/>', 18) + '</button>';
        teaser.addEventListener('click', function (e) {
          var b = e.target.closest('[data-bmp-action]');
          if (!b) return;
          if (b.getAttribute('data-bmp-action') === 'open-from-teaser') {
            emit('teaser', { action: 'open' });
            open('teaser');
          } else {
            sSet('l', K.dismissed, Date.now() + cfg.suppressDays * 86400000);
            removeTeaser();
            emit('teaser', { action: 'dismiss' });
          }
        });
        doc.body.appendChild(teaser);
        watchQuickAdd();
        emit('teaser', { action: 'show' });
      });
    }
    function hideTeaser() { if (teaser) teaser.hidden = true; }
    function removeTeaser() {
      if (teaser && teaser.parentNode) teaser.parentNode.removeChild(teaser);
      if (teaser && teaser.bmpObserver) teaser.bmpObserver.disconnect();
      teaser = null;
    }
    function watchQuickAdd() {
      var bar = doc.querySelector('.product-quick-add');
      if (!bar || !w.MutationObserver) return;
      var t = teaser;
      var update = function () {
        var on = bar.classList.contains('is-visible');
        t.classList.toggle('bmp-teaser--raised', on);
        if (on) {
          var bottom = parseFloat(w.getComputedStyle(bar).bottom) || 0;
          t.style.setProperty('--bmp-quick-add-h', Math.round(bar.offsetHeight + bottom) + 'px');
        }
      };
      t.bmpObserver = new MutationObserver(update);
      t.bmpObserver.observe(bar, { attributes: true, attributeFilter: ['class'] });
      update();
    }

    // ---- Desktop triggers ----
    function armDesktop() {
      var timer = null, raf = 0;
      // Never take the focus from a shopper who is busy: an Impact drawer or modal is open (html.lock)
      // or they are typing in a field. The timer tries again shortly, scroll and exit intent fire again anyway.
      function busyElsewhere() {
        if (doc.documentElement.classList.contains('lock')) return true;
        var a = doc.activeElement;
        if (!a || a === doc.body || (els && els.dialog.contains(a))) return false;
        return /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || !!a.isContentEditable;
      }
      function fire(reason) {
        if (state.open || !state.eligible) { teardown(); return; }
        if (busyElsewhere()) {
          log('trigger deferred', reason);
          if (reason === 'timer') timer = setTimeout(function () { fire('timer'); }, TRIGGER_RETRY_MS);
          return;
        }
        teardown();
        sSet('s', K.shown, '1');
        open(reason);
      }
      function onScroll() {
        if (raf) return;
        raf = w.requestAnimationFrame(function () {
          raf = 0;
          var max = doc.documentElement.scrollHeight - w.innerHeight;
          var y = w.scrollY || w.pageYOffset || 0;
          if (y > 0 && max > 0 && y / max >= cfg.scrollDepth) fire('scroll');
        });
      }
      function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) fire('exit-intent');
      }
      function teardown() {
        clearTimeout(timer);
        w.removeEventListener('scroll', onScroll);
        doc.removeEventListener('mouseout', onOut);
      }
      timer = setTimeout(function () { fire('timer'); }, cfg.delaySeconds * 1000);
      w.addEventListener('scroll', onScroll, { passive: true });
      if (cfg.exitIntent) doc.addEventListener('mouseout', onOut);
      log('desktop triggers armed');
    }

    // ---- Init ----
    function evaluate(identified) {
      var res = evaluateSuppression({
        enabled: cfg.enabled,
        pathExcluded: isExcludedPath(w.location.pathname, cfg.excludedPaths),
        search: w.location.search,
        sessionSuppressed: !!sGet('s', K.session),
        subscribed: isSubscribed(),
        dismissedUntil: dismissedUntil(),
        now: Date.now(),
        identified: identified
      });
      if (res.suppressSession) sSet('s', K.session, res.suppressSession);
      state.eligible = res.eligible;
      state.reason = res.reason;
      return res;
    }

    function klaviyoIdentified() {
      var k = w.klaviyo;
      if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(false);
      return new Promise(function (resolve) {
        var t = setTimeout(function () { resolve(false); }, 1500);
        Promise.resolve().then(function () { return k.isIdentified(); }).then(function (v) {
          clearTimeout(t); resolve(v === true);
        }, function () { clearTimeout(t); resolve(false); });
      });
    }

    function init() {
      if (qa === 'off') { state.reason = 'off'; return; }
      if (qa === 'reset') clearStorage();
      if (!cfg.enabled) { state.reason = 'disabled'; return; }
      state.isMobile = w.innerWidth < cfg.mobileBreakpoint;
      if (cfg.designMode) { state.reason = 'design_mode'; return; }
      sSet('s', K.pageviews, (Number(sGet('s', K.pageviews)) || 0) + 1);
      if (qa === 'force') { state.reason = 'force'; open('force'); return; }
      var res = evaluate(isKlaviyoIdentifiedCookie(doc.cookie));
      log('eligibility', res.reason);
      if (!res.eligible) return;
      klaviyoIdentified().then(function (identified) {
        if (identified && evaluate(true).eligible === false) { log('eligibility', 'identified'); return; }
        if (state.isMobile) {
          if ((Number(sGet('s', K.pageviews)) || 0) >= cfg.mobileMinPageviews) showTeaser();
        } else if (!sGet('s', K.shown)) {
          armDesktop();
        }
      });
    }

    function onEditor(e) {
      var id = e && e.detail && e.detail.sectionId;
      if (!cfg.designMode || !id || id !== cfg.sectionId) return;
      if (e.type === 'shopify:section:select') open('editor');
      else if (e.type === 'shopify:section:deselect') close('api');
      else if (e.type === 'shopify:section:load') {
        var el = doc.getElementById('bmp-popup-config');
        if (el) cfg = parseConfig(el.textContent, currentScript && currentScript.src);
        api.config = cfg;
        if (state.open) close('api');
        if (els) { els.dialog.parentNode.removeChild(els.dialog); els = null; }
      }
    }
    ['select', 'deselect', 'load'].forEach(function (t) { doc.addEventListener('shopify:section:' + t, onEditor); });

    // Runtime switch for the prototype: only mode, demoOutcome, debug.
    function configure(partial) {
      var p = partial && typeof partial === 'object' ? partial : {};
      // invalid values are ignored, so a typo never switches to live sending
      if (p.mode === 'demo' || p.mode === 'live') cfg.mode = p.mode;
      if (p.demoOutcome === 'error' || p.demoOutcome === 'success') cfg.demoOutcome = p.demoOutcome;
      if ('debug' in p) cfg.debug = bool(p.debug, cfg.debug);
      log('configure', p);
      return cfg;
    }

    // Clears storage AND runtime state, so open() afterwards is a fresh first visit without a reload.
    function reset() {
      clearStorage();
      state.gen++;
      state.spinId++;
      state.spinning = false;
      state.busy = false;
      state.amounts = { private: null, business: null };
      state.subscribed = false;
      if (!els) { state.rotation = { private: 0, business: 0 }; state.step = null; return; }
      KINDS.forEach(function (k) {
        setRotor(k, 0);
        clearWin(k);
        setStepDisabled(els.steps[k], false);
      });
      resetForms();
      setStep('choose', true);
    }

    var api = {
      version: VERSION,
      config: cfg,
      open: function (reason, options) { return open(reason || 'api', options); },
      configure: configure,
      close: function (reason) { close(reason || 'api'); },
      reset: reset,
      // simulate(n, 'business') draws from the business wheel, default is the private one.
      simulate: function (n, kind) {
        var wheel = WHEELS[kind] || WHEELS.private;
        n = Math.max(1, Math.floor(Number(n) || 1000));
        var counts = {};
        wheel.odds.forEach(function (o) { counts[o.amount] = 0; });
        for (var i = 0; i < n; i++) counts[drawAmount(null, wheel)]++;
        var rows = wheel.odds.map(function (o) {
          return { Betrag: o.amount + ' €', Anzahl: counts[o.amount], Prozent: (counts[o.amount] / n * 100).toFixed(1) + ' %' };
        });
        if (typeof console !== 'undefined' && console.table) console.table(rows);
        return counts;
      },
      getState: function () {
        var du = dismissedUntil();
        return {
          eligible: state.eligible, reason: state.reason, isMobile: state.isMobile,
          pageviews: Number(sGet('s', K.pageviews)) || 0, shownThisSession: sGet('s', K.shown) === '1',
          dismissedUntil: du || null, subscribed: isSubscribed(), wheelAmount: currentAmount('private'),
          businessWheelAmount: currentAmount('business'), step: state.step, open: state.open
        };
      }
    };
    w.BMPNewsletterPopup = api;

    function start() {
      var idle = w.requestIdleCallback ? function (fn) { w.requestIdleCallback(fn, { timeout: 2000 }); } : function (fn) { setTimeout(fn, 1); };
      idle(function () { try { init(); } catch (e) { warn('init failed: ' + (e && e.message)); } });
    }
    if (doc.readyState === 'complete') start(); else w.addEventListener('load', start);
  }

  return { internals: internals, boot: boot };
});
